<template>
  <v-container class="footer__secondary-links-container">
    <div class="footer__secondary-links-placeholder">
      <footer-bottom-link v-for="item in fields.items" :key="item.name" :fields="item.fields"></footer-bottom-link>
      <sc-placeholder
        name="jssfooterbottomlinks"
        :rendering="rendering"
      />
    </div>
  </v-container>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import FooterBottomLink from './sub-components/FooterBottomLink.vue';

export default {
  name: 'FooterBottomLinks',
  data() {
    return {};
  },
  props: {
    rendering: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
    },
  },
  components: {
    ScPlaceholder: Placeholder,
    FooterBottomLink: FooterBottomLink
  },
};
</script>
<style lang="scss" scoped>
.footer {
  &__secondary-links-container {
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 12px;
    }
  }

  &__secondary-links-placeholder {
    display: block;

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      display: flex;
      justify-content: flex-end;
      flex-shrink: 1;
    }
  }
}
</style>
<style lang="scss">
.footer__secondary-links-container {
  a.footer__secondary-link:hover {
    text-decoration: underline;
  }

  .footer__secondary-link-wrapper {
    padding: 10px 0;
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      padding: 10px 0;
    }

    .footer__secondary-link {
      text-decoration: none;
      display: inline;
      color: $_white;
      padding: 0 12px;

      @media #{map-get($display-breakpoints, 'xs-only')} {
        padding: 0;
      }
    }
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      &::before {
        content: '|';
      }
    }
  }

  .footer__secondary-link-wrapper:first-child {
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      &::before {
        content: '';
      }
    }
  }
  .footer__secondary-link-copyright {
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      &::before {
        content: '|' !important;
      }
    }
  }
}
</style>
